import React, {useEffect, useRef, useState} from 'react';
import InputCodeArrowIcon from "../Images/InputCodeArrowIcon";
import ActionButton from "../Buttons/ActionButton";
import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import WebApp from "@twa-dev/sdk";
import {sendCode, sendFinishTutorial, setClaimed} from "../../store/tutorialSlice";
import {showTutorialMessage} from "../../store/notificationSlice";
import {getTutorialClaim} from "../../store/userSlice";
import InfinityBlackIcon from "../../assets/images/infinity-black-icon.svg";
import router from "../../router/router";

const FormBlock: React.FC = () => {
    const blockRef = useRef<HTMLFormElement>(null);
    const [codeInput, setCodeInput] = useState('');
    const [type, setType] = useState('disabled')
    const dispatch = useAppDispatch();
    const slideState = useAppSelector((state) => state.slide)
    const codeStatus = useAppSelector((state) => state.codes.status)

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target.value;
        if (input.length <= 3) {
            setCodeInput(input);
        }
    };

    useEffect(() => {
        if(codeStatus === 'fulfilled_correct') {
            WebApp.HapticFeedback.notificationOccurred('success');
        }
        if(codeStatus === 'fulfilled_incorrect' || codeStatus === 'fulfilled_max') {
            WebApp.HapticFeedback.notificationOccurred('error');
        }
    }, [codeStatus]);

    useEffect(() => {
        codeInput.length === 3 ? setType('active') : setType('disabled');
    }, [type, codeInput]);

    const submitHandler =   (e: React.SyntheticEvent ) => {
        e.preventDefault();
        if(codeInput.length < 3) {
            return;
        }
        dispatch(sendCode({guess: codeInput.toUpperCase(), day: slideState.day, season: slideState.season }))
        setCodeInput('');
    }

    useEffect(() => {
        if(slideState.completed_at && !slideState.claimed) {
            dispatch(getTutorialClaim({reward: slideState.reward}));
            dispatch(setClaimed())
            dispatch(sendFinishTutorial())
            dispatch(showTutorialMessage({data: {message: `You’ve earned:<br> <b style="font-size: 25px">+${slideState.reward}</b> <img src=${InfinityBlackIcon} alt="Infinity"/>`, type: 'info', show: true}}))
            router.navigate('/tutorial/main')
        }
    }, [slideState.completed_at]);

    return (
        <Container ref={blockRef}  onSubmit={submitHandler}>
            {codeStatus !== 'fulfilled_max' &&
                <>
                    <InputWrapper>
                        <ArrowLeft><InputCodeArrowIcon/></ArrowLeft>
                        <Input name="code" id="code" placeholder="enter code here" value={codeInput} onChange={handleInputChange} type="text" spellCheck={false} minLength={5} maxLength={5} enterKeyHint="send" autoComplete="off" autoCorrect="off" />
                        <ArrowRight><InputCodeArrowIcon/></ArrowRight>
                    </InputWrapper>
                    <ActionButton width="100%" height="48px" type={type}
                                  clickHandler={submitHandler}>try</ActionButton>
                </>
            }
        </Container>
    );
};

export default FormBlock;

const Container = styled.form`
    margin-top: 16px;
    margin-bottom: 20px;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    z-index: 1;
`;
const InputWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
`;
const Input = styled.input`
    display: block;
    min-height: 38px;
    height: 48px;
    padding: 0 40px;
    border: 1px solid #fff;
    background-color: rgba(255,255,255,.1);
    width: 100%;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 12px;
    text-indent: 12px;
    text-align: center;
    text-transform: uppercase;
    &::placeholder {
        font-size: 16px;
        letter-spacing: 1px;
        text-indent: 1px;
        opacity:  .5;
        text-transform: initial;
        color: #F1D988;
    }
`;
const ArrowLeft = styled.div`
    position: absolute;
    left: 26px;
    height: 17px;
`;
const ArrowRight = styled.div`
    position: absolute;
    transform: rotate(180deg);
    right: 26px;
    height: 17px;
`;
